import axios from "axios";
import * as yup from "yup";
import { buildQuery } from "utils/queryUtils";

let schema = yup.object().shape({
    name: yup.string().test("not-blank", "name.required", (name) => name?.length > 0),
    appType: yup.number().test("app-version", "version.appType.required", (appType) => !!appType),
});

export const validateAppVersion = (appVersion) => {
    return schema.validate(appVersion, { abortEarly: false });
};

export const findAppVersions = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/app-versions${query}`, {
        headers,
    });
};

export const findAppVersionById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/app-versions/${id}`, {
        headers,
    });
};

export const createAppVersion = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_ACM_API_URL}/app-versions`, data, {
        headers,
    });
};

export const updateAppVersion = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_ACM_API_URL}/app-versions/${id}`, data, {
        headers,
    });
};

export const deleteAppVersion = (headers, id) => {
    return axios.delete(`${process.env.REACT_APP_ACM_API_URL}/app-versions/${id}`, {
        headers: headers,
    });
};
